// Packages
import { createAction } from 'redux-actions'

// Constants
import { ADD_ITEM, REMOVE_ITEM, REMOVE_ALL } from '../constants/ImportItems'

export const addItemAction = createAction(ADD_ITEM)
export const removeItemAction = createAction(REMOVE_ITEM)
export const removeAllImportItems = createAction(REMOVE_ALL)
